module.exports = __webpack_public_path__ + "static/media/meeza-ic.0e59e902.svg";